module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_quiz_flashcards_blue-de1a42420479974cbfe5d48114f1ce0f.svg";